<template>
  <v-app>
    <Navbar v-if="$route.name !== 'login'" />
    <v-content>
      <router-view />
    </v-content>
    <Footer />
  </v-app>
</template>

<script>
  import { get, post, put, destroy } from "./service/Axios";
  import Footer from "./components/Footer";  
  import Navbar from "./components/Navbar"; 
  import firebaseapp from "firebase";
  import firebase from "./plugins/Firebase";
  export default {
    components: {
      Footer,
      Navbar
    },
    computed: {
      token () {
        return this.$store.state.token
      }
    },
    watch: { 
      '$route' (to, from) { 
        this.tokenFirebase()
      } 
    },
    methods: {
      tokenFirebase() {
        if (firebase.messaging.isSupported()) {
          if (!this.token) {
            navigator.permissions.query({ name: 'notifications' })
            .then(function(result) {
              if (result.state === 'granted') {
                firebaseapp.messaging().getToken()
                .then(oldToken => {
                  if (oldToken === localStorage.getItem('TOKEN_FCM')) {
                    console.log('Token delete ', oldToken)
                    firebaseapp.messaging().deleteToken(oldToken)
                    localStorage.setItem('TOKEN_FCM', '')
                  } else {
                    console.log('Token is deleted')
                  }
                })
              }
            })
          } else {
            navigator.permissions.query({ name: 'notifications' })
            .then(function(result) {
              if (result.state !== 'granted') {
                firebaseapp.messaging().requestPermission()
                .then(function() {
                  window.location.reload()
                })
                .catch(function(err) {
                  console.log('Unable to get permission to notify', err)
                })
              }
            })

            firebaseapp.messaging().getToken()
            .then(refreshedToken => {
              console.log('Token refresh ', refreshedToken)
              this.updateTokenFirebase(refreshedToken)
            })
            .catch(function(err) {
              console.log('Unable to retrieve token', err)
            })
          }
        }
      },
      async updateTokenFirebase(refreshedToken) {
        if (refreshedToken !== localStorage.getItem('TOKEN_FCM')) {
          await put(`internal/update/fcm`, {
            data: {
              tokenFcm: refreshedToken
            }
          })
          .then ((response) => {
            localStorage.setItem('TOKEN_FCM', refreshedToken)
          })
        }
      }
    },
    created() {
      if (process.browser) {
        if ('Notification' in window && 'serviceWorker' in navigator) {
          this.tokenFirebase()
        }
      }
    }
  }
</script>

<style>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: left;
  color: #2c3e50;
}

#content {
  padding: 0px;
}
</style>